import React from 'react';
import DetailDistribution from 'components/Tvendo/Distribution/Operations/TrackingDist/DetailTrackingDist.js';

export default function DistributionTracking() {
  return <DetailDistribution />;
}
